<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:<span v-if="required" class="text-red-500">*</span></label>
    <div class="relative">
      <font-awesome-icon icon="fa-regular fa-clock" class="cursor-pointer z-10 absolute top-1/2 transform -translate-y-1/2 left-3" @click="() => this.$refs.timeinput.openMenu()" />
      <input ref="input" v-mask="'##:##'" :id="id" v-bind="{ ...$attrs, class: null }" class="form-input pl-8" :class="{ error: error }" type="tel" :value="this.inputValue" @change="changeTime" @keyup="keyup" autocomplete="off" />
    </div>
    <Datepicker ref="timeinput" v-model="this.value" modelType="HH:mm" autoApply :clearable="false" :format="format" :class="{ error: error }" timePicker locale="pt-BR">
      <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
      </template>
    </Datepicker>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import ptBR from 'date-fns/locale/pt-BR';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import {mask, TheMask} from 'vue-the-mask'

export default {
  data() {
    return {
      value: null,
      inputValue: null,
    }
  },
  mounted() {
    this.fillValues(this.modelValue);
  },
  watch: {
    modelValue(valueNew, valueOld) {
      this.fillValues(this.modelValue);
    },
    value(valueNew, valueOld) {
      let modelValue = null;
      if(this.value) {
        modelValue = this.value.hours.toString().padStart(2, '0') + ':' + this.value.minutes.toString().padStart(2, '0');
      }
      this.inputValue = modelValue;
      this.$emit('update:modelValue', modelValue);
    },
  },
  components: {
    Datepicker,
    ptBR,
    format,
    parse,
    TheMask,
  },
  directives: {
    mask
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    required: String,
    error: String,
    label: String,
    modelValue: String,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    format: (date) => date.hours.toString().padStart(2, '0') + ':' + date.minutes.toString().padStart(2, '0'),
    /*format(date) {
      return date.hours + ':' + date.minutes;
    },*/
    keyup(input) {
      this.$refs.timeinput.closeMenu();
    },
    fillValues(value) {
      if(value) {
        this.inputValue = value;
        let time = value.split(':');
        this.value = {
          hours: time[0],
          minutes: time[1],
          seconds: 0,
        };
      } else {
        this.value = null;
        this.inputValue = null;
      }
    },
    changeTime(input) {
      let time = input.target.value;
      let hours = time.substr(0, 2);
      let minutes = time.substr(3, 2);
      if(time.length && hours < 24 && minutes < 60) {
        this.value = {
          hours: hours,
          minutes: minutes,
          seconds: 0,
        };
      } else {
        this.value = null;
      }
    },
  },
}
</script>
